export default __webpack_public_path__ + "static/media/karigar.fe785a2f.jpg";